import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=a798e07a&"
import script from "./card-detail.vue?vue&type=script&lang=js&"
export * from "./card-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports